import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'mandae-step',
  templateUrl: './step.component.html',
  styleUrls: ['./step.component.scss']
})
export class StepComponent {

  @Input() number = 1;
  @Input() description = '';
  @Input() complete = false;
  @Input() isReversible = false;

  @Output() linkClick = new EventEmitter<void>();
  @Output() undoClick = new EventEmitter<void>();

  public get linkActive() {
    return !this.complete;
  }

  public handleClick(event: MouseEvent) {
    event.preventDefault();

    this.linkClick.emit();
  }

  public handleUndoClick(event: MouseEvent) {
    event.preventDefault();

    this.undoClick.emit();
  }

}
